// 真实时间差计时（EP-005-S2 / GDD 02 §②-2.1）。
//
// 核心约束：进度只由「now - departureTimestamp」一次性算得，禁止任何 interval/tick 累加。
// CI 守门 check-no-tick-accumulator 会抓形如 elapsed 与 interval 相加的实现。
//
// 入参 durationMs 来自 trip.travelDurationMs（出发时固化），此处只做除法。
// - 系统时间被回拨（now < departureTimestamp）：elapsed 钳到 0，按「刚出发」处理（GDD 02 T3）。
// - durationMs <= 0（配置写错）：兜底视为已回归（GDD 02 T13）。
export function computeElapsed(
  departureTimestamp: number,
  now: number,
  durationMs: number,
): { progress: number; ready: boolean } {
  const elapsed = Math.max(0, now - departureTimestamp);
  if (!(durationMs > 0)) {
    return { progress: 1, ready: true };
  }
  const raw = elapsed / durationMs;
  const progress = raw <= 0 ? 0 : raw >= 1 ? 1 : raw;
  return { progress, ready: elapsed >= durationMs };
}
